<template lang="html">
  <div class="teacher">
    <div class="content" v-if='code >= 0'>
      <p class="teacherNum">该高校共关联 {{ teacherList.total }} 位院系老师</p>
      <div v-for="a in teacherList.data" :key="a.uid" class="teacherList" @click="goTeacher(a.uid)">
        <img :src="a.avatar" alt="" class="teacherAvatar">
        <div class="teacherCon">
          <div class="teacherName">
            <p>{{ a.real_name }}</p>
            <img src="@/assets/image/icon/tv.png" alt="" v-show="a.mp_type">
          </div>
          <div class="teacherHit">
            {{ a.cate_name }}
          </div>
        </div>
        
        <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + a.uid" />
      </div>
    </div>
    
    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
      </div>
      <p>暂无内容哦~</p>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'
  import WxOpenTag from '@/components/WxOpenTag';
  
  export default {
    props: ['userId'],
    
    data() {
      return {
        code: '',
        teacherList: {
          data:{}
        },
        pagebase: pagebase,
      }
    },
    
    components: {
      WxOpenTag,
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getTeacherList()
      },

      getTeacherList() {
        this.$http({
          url: '/user/getRelationTeacherList',
          method: 'get',
          params: {
            relation_uid: this.userId,
            page: 1,
            limit: 10,
          }
        }).then(res => {
          this.code = res.code;
          if (res.code >= 0) {
            this.teacherList = res.data;
          }
        })
      },
      
      goTeacher(uid) {
        sessionStorage.setItem('cur', 7);
        this.$router.push({
          path: '/elecOM',
          query: {
            uid: uid,
          }
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .teacher {
    box-sizing: border-box;
    padding: 0 1.5rem;
  }
  
  .teacherNum {
    font-size: 1.4rem;
    color: #1D2023;
    padding-top: 1.5rem;
  }
  
  .teacherList {
    position: relative;
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    border-bottom: .05rem solid #EBEEF5;
  }
  
  .teacherAvatar {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .teacherCon {
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .teacherName {
    font-size: 1.4rem;
    color: #333333;
    display: flex;
    align-items: center;
  }
  
  .teacherName img{
    width: 1.2rem;
    height: 1.2rem;
    margin-left: .5rem;
  }
  
  .teacherHit {
    color: #9CA3A9;
    font-size: 1.2rem;
  }
  
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
